import DomainResource from './DomainResource';
import merge from 'lodash/merge';
import BN_MedicationPresetItem from './BN_MedicationPresetItem';

/**
 * A named list of medication orders kept for the whole account. Archived (status inactive),
 * never deleted.
 */
export default class BN_MedicationPreset extends DomainResource {
    static __className = 'BN_MedicationPreset';

    __objectStructure = {
        name: String,
        description: String,
        status: String, // active | inactive
        item: [BN_MedicationPresetItem],
    };

    constructor(constructJson, className = 'BN_MedicationPreset') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
